import React, { useEffect, useState } from 'react';
import { BsCheckLg } from 'react-icons/bs';
import './checkbox.modules.css';
//import { CSSTransition } from 'react-transition-group';

const CheckBox = ({ id, label, checked, onClick, ...props }) => {

    const defaultChecked = checked ? checked : false;
    const [isChecked, setIsChecked] = useState(defaultChecked);

    const onCLickCheckBoxHandler = () => {
        setIsChecked(state => state = !state);
    };

    useEffect(() => {
        onClick(isChecked);
    }, [isChecked]);

    return (
        <div className="checkbox-wrapper">
            <label htmlFor={id}>{label}</label>
            <div className='checkbox' onClick={onCLickCheckBoxHandler}>
                {isChecked && <BsCheckLg />}
            </div>
        </div>
    )
};

export default CheckBox;
